export default __webpack_public_path__ + "static/media/Step 3 Image.fff68186.png";